var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"slice-call-out-row min-h-130 md_min-h-16vw px-20 bg-teal py-20 md_py-60 flex items-center"},[_c('rich-text',{staticClass:"w-full md_w-8x12 md_ml-3x12 md_px-20 text-18 md_text-20 xl_text-24",domProps:{"innerHTML":_vm._s(_vm.slice.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }